export const emitEvent = (element, name, detail, bubbles = true, composed = true) => {
    element.dispatchEvent(new CustomEvent(name, { bubbles, composed, detail }));
};
//# sourceMappingURL=events.js.map